import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidationTypeEnum } from '@app/components/invoice/invoices.model';
import { ButtonIcon, ButtonStyle } from '@app/shared/components/atoms/buttons/button.type';
import { IconComponent, Size, Style } from '@app/shared/components/atoms/icon/icon.component';
import { Color } from '@app/shared/models/color.model';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  imports: [CommonModule, IconComponent],
  standalone: true,
})
export class ToggleSwitchComponent<T extends string> {
  @Input() disabled: boolean = false;

  @Input() icon: boolean = false;

  @Input({}) options?: T[];

  @Input() currentOption?: T;

  @Input() size?: 'small' | 'medium' | 'large' = 'small';

  @Input() background?: 'validate' | 'refused' | '' = '';

  @Output() currentOptionChange = new EventEmitter<T>();

  @Input() defaultOption!: T;

  protected readonly ValidationTypeEnum = ValidationTypeEnum;

  protected readonly ButtonIcon = ButtonIcon;

  protected readonly ButtonStyle = ButtonStyle;

  protected readonly Style = Style;

  protected readonly Color = Color;

  onToggle(option: T) {
    this.currentOption = option;
    this.currentOptionChange.emit(option);
  }

  protected readonly Size = Size;
}
